module.exports = {"540232100":"帕羊镇","540232200":"拉让乡","540232201":"琼果乡","540232202":"亚热乡","540232203":"布多乡","540232204":"偏吉乡","540232205":"纳久乡","540232206":"吉拉乡","540232207":"霍尔巴乡","540232208":"隆格尔乡","540232209":"吉玛乡","540232210":"仁多乡","540232211":"帕江乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/540232.json
// module id = 2699
// module chunks = 0